const permissionGroupsKeys = {
  module: ['permissionGroups'] as const,
  list: () => [...permissionGroupsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...permissionGroupsKeys.list(), filters] as const,
  details: (id: string) =>
    [...permissionGroupsKeys.module, 'details', id] as const,
};

export default permissionGroupsKeys;
